import { Theme, alpha } from '@mui/material/styles';
//
import { ColorSchema } from '../palette';

declare module '@mui/material/ToggleButton' {
    interface ToggleButtonPropsColorOverrides {
        tertiary: true;
        tertiaryLight: true;
    }
}

// ----------------------------------------------------------------------

export default function ToggleButton(theme: Theme) {
    const style = (color: ColorSchema) => ({
        props: { color },
        style: {
            '&:hover': {
                backgroundColor: alpha(
                    theme.palette[color].main,
                    theme.palette.action.hoverOpacity
                ),
            },
            padding: theme.spacing(0.75, 2),
        },
    });

    return {
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    color: theme.palette.text.primary,
                    '&.Mui-selected': {
                        color: `${theme.palette.primary.main} !important`,
                        backgroundColor: alpha(theme.palette.primary.main, 0.16),
                        '&:hover': {
                            backgroundColor: alpha(theme.palette.primary.main, 0.24),
                        },
                    },
                },
            },
            variants: [
                {
                    props: { color: 'standard' },
                    style: {
                        '&.Mui-selected': {
                            color: `${theme.palette.primary.main} !important`,
                            backgroundColor: alpha(theme.palette.primary.main, 0.08),
                            '&:hover': {
                                backgroundColor: alpha(theme.palette.primary.main, 0.16),
                            },
                        },
                    },
                },
                style('primary'),
                style('secondary'),
                style('info'),
                style('success'),
                style('warning'),
                style('error'),
                style('tertiary'),
                style('tertiaryLight'),
            ],
        },
    };
}
